var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"folder-btn"},[_c('font-awesome-icon',{attrs:{"icon":"edit"},on:{"click":function($event){return _vm.$emit('openEditor')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }